import { OptimizelySubitoFeature } from '@sbt-web/houston-wrapper';
import React from 'react';
import dynamic from 'next/dynamic';

const Banner = dynamic(() => import('./banner'), {
  ssr: false,
});

const GalleryCTA: React.FunctionComponent = () => {
  return (
    <OptimizelySubitoFeature feature="subito-product-marketing.listing.gallery-banner">
      {(enabled, features) => {
        if (enabled) {
          return (
            <Banner
              title={features.title}
              body={features.body}
              imageSrc={features.image}
              imageAlt={features.alt}
              imageWidth={features.imageWidth}
              imageHeight={features.imageHeight}
              buttonText={features.buttonText}
              buttonURL={features.buttonURL}
            />
          );
        }
      }}
    </OptimizelySubitoFeature>
  );
};

export default GalleryCTA;
